import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

const SurgeonsTableMobile = ({ surgeons = [], users = [], hospitals = [] }) => {
    const getUserName = useCallback((uid) => {
      const user = users.find((u) => u.uid === uid);
      return user ? `Dr ${user.firstName} ${user.lastName}` : '';
    }, [users]);

    const getHospitalNames = useCallback((ids) => {
      if (!ids) {
        return '';
      }

      const names = ids.map((id) => hospitals?.find((item) => item.id === id)?.name);

      return names?.filter((name) => !!name)?.join(', ');
    }, [hospitals]);

    return (
    <div className="cases-table-mobile">
      {surgeons.map((surgeon) => {
        return (
          <div key={surgeon.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{getUserName(surgeon?.userId)}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {getHospitalNames(surgeon?.hospitals)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

SurgeonsTableMobile.propTypes = {
  surgeons: PropTypes.array,
};

export default memo(SurgeonsTableMobile);
